// extracted by mini-css-extract-plugin
export default {"alert":"CardExpireAlert_alert__TGh9H","btn":"CardExpireAlert_btn__oz3Ej"};